import { DEFAULT_SORT_BEHAVIOUR, SORT_DIRECTIONS, SORT_MAPPINGS } from "@/AdminComponent/Reactions/constants/sortValues";

export const getSortDirection = (sortBy, columnKey) => {
	const mapping = SORT_MAPPINGS[columnKey];
	if (!mapping) return null;

	if (sortBy === mapping[SORT_DIRECTIONS.ASC]) return SORT_DIRECTIONS.ASC;
	else if (sortBy === mapping[SORT_DIRECTIONS.DESC]) return SORT_DIRECTIONS.DESC;
	return null;
};

export const getNextSortValue = (columnKey, sortBy) => {
	const currentDirection = getSortDirection(sortBy, columnKey);
	const mapping = SORT_MAPPINGS[columnKey];
	if (!mapping) return '';

	if (currentDirection === SORT_DIRECTIONS.ASC) return mapping[SORT_DIRECTIONS.DESC];
	if (currentDirection === SORT_DIRECTIONS.DESC) return mapping[SORT_DIRECTIONS.ASC];
	return mapping[DEFAULT_SORT_BEHAVIOUR[columnKey]];
};
